import React, { Fragment, useEffect, useRef } from "react";
import PropTypes from "prop-types";

const VipNewebpay = ({ record }) => {
  const formRef = useRef(undefined);
  useEffect(() => {
    formRef.current.submit();
  }, []);

  return (
    <Fragment>
    <div><br /><br /><center><img src="/p/image/e_3.png" /><br /><br /><h4>付款頁面轉跳中，請稍候...</h4></center></div>
    <form ref={formRef} method="POST" action={`${record.newebpay_site}`}>
      <input type="hidden" name="MerchantID" value={record.MerchantID} readOnly /><br />
      <input type="hidden" name="Version" value={record.Version} readOnly /><br />
      <input type="hidden" name="TradeInfo" value={record.TradeInfo} readOnly /><br />
      <input type="hidden" name="TradeSha" value={record.TradeSha} readOnly /><br />
    </form>
    </Fragment>
  );
};

VipNewebpay.propTypes = {
  record: PropTypes.object.isRequired,
};

export default VipNewebpay;
